export default "__VITE_ASSET__DtwsxL9k__"